angular.module("rightPaneModule")
  .directive('bindFile', [function () {
    return {
      require: "ngModel",
      restrict: 'A',
      link: function ($scope, el, attrs, ngModel) {
        el.bind('change', function (event) {
          ngModel.$setViewValue(event.target.files[0]);
          $scope.$apply();
        });

        $scope.$watch(function () {
          return ngModel.$viewValue;
        }, function (value) {
          if (!value) {
            el.val("");
          }
        });
      }
    };
  }]);
